import { useEffect, useState } from 'react';

// A ticking "now" for elapsed-time displays (OLIO-2602): the clock advances on its own
// cadence instead of riding the data-fetch cadence — with polling demoted in favor of
// live updates, an elapsed column would otherwise freeze between server events.
export default function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
